module.exports = __webpack_public_path__ + "img/img (11).7d55d1b5.jpg";